import lazyLoad from "../../components/lazyLoad";
import intlTelInput from "../../components/forms/intlTelInput";
import searchSelect from "../../components/forms/searchSelect";
import formValidation from "../../components/forms/formValidation";
import select from "../../components/forms/select";
import scrollbar from "../../components/scrollbar";
import gallery from "../../components/gallery";
import toast from "../../components/toasts";
import notify from "../../components/notify";
import modal from "../../components/modal";
import errorHandler from "../../api/errorHandler";

import fixedHeader from "../common/fixedHeader";
import reviews from "../common/reviews";
import animationCommon from "../common/animation";
import feedback from "../common/feedback";
import langSwitch from "../common/langSwitch";

import animation from "./animation";
import descriptionCarousel from "./descriptionCarousel";

export default function(currentPage) {

    return [
        lazyLoad.bind(null, 200),
        intlTelInput,
        searchSelect,
        formValidation,
        scrollbar,
        select,
        gallery,
        toast,
        errorHandler,
    
        fixedHeader,
        reviews,
    
        animationCommon.bind(currentPage, [
            {
                name: 'description',
                axis: 'x',
                oddAxis: true
            },
            {
                name: 'conditions',
                axis: 'y',
                oddAxis: false
            },
            {
                name: 'feedback',
                axis: 'x',
                oddAxis: true
            },
            {
                name: 'footer',
                axis: 'x',
                oddAxis: true
            }
        ]),
        animation,
        notify,
        modal,

        descriptionCarousel,
        feedback,
        langSwitch
    ]
}